import { render, staticRenderFns } from "./approvalInput.vue?vue&type=template&id=a8a522e0&"
import script from "./approvalInput.vue?vue&type=script&lang=js&"
export * from "./approvalInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports